import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	style: {
		margin: "auto",
		background: "none",
		display: "block",
		shapeRendering: "auto"
	},
	width: "20px",
	height: "20px",
	viewBox: "0 0 100 100",
	preserveAspectRatio: "xMidYMid",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		fill: "none",
		stroke: "#ffffff",
		strokeWidth: 10,
		r: 31,
		strokeDasharray: "146.08405839192537 50.69468613064179",
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			type: "rotate",
			repeatCount: "indefinite",
			dur: "1.075268817204301s",
			values: "0 50 50;360 50 50",
			keyTimes: "0;1"
		})
	})]
});
const ForwardRef = forwardRef(SvgLoading);
export { ForwardRef as ReactComponent };
